import React, { useState, useEffect, useContext } from "react"
import { CilarContext } from "../../contexts/cilarContext"
import {
  FeaturedContainer,
  HeadingContainer,
  PageTitle,
  BlogDescription,
  BlogContainer,
  BlogGrid,
  BlogCard,
  BlogPreviewImage,
  Title,
  BlogContentPreview,
  PageCounterContainer,
  PageCounter,
  PageButton,
  BlogLink,
  BlogPreviewText,
  BlogContentPreviewMobile
} from './newsStyle'
import { gql, useQuery } from '@apollo/client'
import { useNavigate } from 'react-router-dom'
import ErrorSection from "../../components/Error/error"

const GET_NEWS = gql`
query GetNews {
  pages(where: {title: "News & Updates"}) {
    nodes {
      newsAndUpdates {
        title
      }
    }
  }
  posts(where: {categoryName: "News"}) {
    nodes {
      slug
      title
      newsArticle {
        title
        slug
        preview
        date
        content
        author
        asset {
          altText
          sourceUrl
        }
        assetInArticleHeader
      }
    }
  }
}
`;

function NewsPage() {
  const { initialLandingAnimationCompleted, textSlideUp } = useContext(CilarContext);
  var pages
  const { loading, error, data } = useQuery(GET_NEWS);
  const navigate = useNavigate()
  const [currPage, setCurrPage] = useState(1)

  if (data) pages = Math.floor(data.posts.nodes.length / 9 + 1)

  const NextPage = () => {
    const currentIndex = currPage
    if (currentIndex !== pages) {
      setCurrPage(currentIndex + 1)
    }
  }

  const PrevPage = () => {
    const currentIndex = currPage
    if (currentIndex !== 1) {
      setCurrPage(currentIndex - 1)
    }
  }

  useEffect(() => {
    if (!initialLandingAnimationCompleted) {
      setTimeout(() => {
        textSlideUp("#newsTitle")
      }, 2000)
    } else {
      setTimeout(() => {
        textSlideUp("#newsTitle")
      }, 1000)
    }
  }, [])

  return (
    <>
      {!loading && !error ?
        <>
          <FeaturedContainer>
            <HeadingContainer>
              <PageTitle id="newsTitle" dangerouslySetInnerHTML={{__html: data.pages.nodes[0].newsAndUpdates.title}}/>
              <BlogDescription>&nbsp;</BlogDescription>
            </HeadingContainer>
          </FeaturedContainer>
          <BlogContainer>
            <BlogGrid>
              {data.posts.nodes.map((post, index) => {
                const maxIndex = currPage * 9 - 1
                const minIndex = maxIndex + 1 - 9

                if (index >= minIndex && index <= maxIndex) {
                  return (
                    <BlogLink key={post.slug} onClick={() => {navigate(`/news/${post.newsArticle.slug}`, {state: {articleId: post.slug}})}}>
                      <BlogCard>
                        <BlogPreviewImage src={post.newsArticle.asset.sourceUrl} />
                        <BlogPreviewText>
                          <Title>{post.newsArticle.title}</Title>
                          <BlogContentPreview>
                            {post.newsArticle.preview.substring(0, 150).trim() + "..."}
                          </BlogContentPreview>
                          <BlogContentPreviewMobile>
                            {post.newsArticle.preview.substring(0, 100).trim() + "..."}
                          </BlogContentPreviewMobile>
                        </BlogPreviewText>
                      </BlogCard>
                    </BlogLink>
                  )
                } else {
                  return <></>
                }
              })}
            </BlogGrid>
          </BlogContainer>
          <PageCounterContainer display={pages > 1 ? "" : "none"}>
            <PageCounter>
              <PageButton onClick={PrevPage}> &#60; </PageButton>
              <p>
                {currPage}/{pages}
              </p>
              <PageButton onClick={NextPage}> &#62; </PageButton>
            </PageCounter>
          </PageCounterContainer>
        </>
        :
        <>
          {error ?
            <ErrorSection/>
            :
            <></>
          }
        </>
      }
    </>
  )
}

export default NewsPage
